import { useState } from "react";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import RefreshIcon from "../../../common/components/icons/RefreshIcon";
import { ISecurityEventsTableRow } from "../../data-hub/components/models/common/events.models";
import RetrieveVideoModal from "./RetrieveVideoModal";
import { CircularProgress } from "@mui/material";

interface RetrieveVideoButtonProps {
  isRetrieveVideoProcessing: boolean;
  handleRetrieveVideo: () => void;
  nodeId?: string;
  deviceId: string;
  timestamp: string;
  s3Key: string;
  row: ISecurityEventsTableRow;
}

const RetrieveVideoButton = ({
  isRetrieveVideoProcessing,
  handleRetrieveVideo,
  nodeId,
  deviceId,
  timestamp,
  s3Key,
  row,
}: RetrieveVideoButtonProps) => {
  const [isRetrieveVideoModalOpen, setIsRetrieveVideoModalOpen] =
    useState(false);

  const handleOpenRetrieveVideoModal = () => {
    setIsRetrieveVideoModalOpen(true);
  };

  const handleCloseRetrieveVideoModal = () => {
    setIsRetrieveVideoModalOpen(false);
  };

  return (
    <>
      <Button
        sx={{
          cursor: "pointer",
        }}
        onClick={handleOpenRetrieveVideoModal}
        variant="outlined"
        size="small"
        disableRipple
        startIcon={
          isRetrieveVideoProcessing ? (
            <CircularProgress size={20} />
          ) : (
            <RefreshIcon />
          )
        }
      >
        <Typography variant="buttonMedium">
          {isRetrieveVideoProcessing ? "Retrieving..." : "Retrieve Video"}
        </Typography>
      </Button>

      <RetrieveVideoModal
        open={isRetrieveVideoModalOpen}
        onClose={handleCloseRetrieveVideoModal}
        nodeId={nodeId}
        startRetrieveVideo={handleRetrieveVideo}
        deviceId={deviceId}
        timestamp={timestamp}
        s3Key={s3Key}
        row={row}
      />
    </>
  );
};

export default RetrieveVideoButton;
